import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { isAddressCompatibleWithChain } from "../utils/balanceUtils";

/**
 * Hook to check if an address is compatible with a given chain identifier.
 * Returns true if the address architecture matches the chain architecture (EVM/SVM).
 */
export function useAddressCompatibility(address, chainIdentifier) {
  const $ = _c(4);
  const {
    getChain
  } = useChains();
  if (!(address && chainIdentifier)) {
    return false;
  }
  let t0;
  if ($[0] !== address || $[1] !== chainIdentifier || $[2] !== getChain) {
    const chain = getChain(chainIdentifier);
    t0 = isAddressCompatibleWithChain(address, chain);
    $[0] = address;
    $[1] = chainIdentifier;
    $[2] = getChain;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}